<template>
  <b-modal
    id="edit-payment-method-modal"
    ref="editPaymentMethodModal"
    modal-class="settings-modal no-multiselect-overflow"
    :body-class="['body-wrapper', 'white-bg']"
    title="Edit payment method"
    hide-header-close
    size="md"
    centered
    @hidden="clear">
    <label class="settings__label">Card</label>
    <StripeCard
      ref="stripeCard"
      :public-key="$env.VUE_APP_STRIPE_PUBLIC"
      @handle-error="handleStripeErrors"
      @complete="complete = true"
      @incomplete="complete = false" />

    <div
      v-if="errorMessage"
      class="error error-color flex flex-align-center">
      <SBIcon
        class="mr-2"
        :icon="SBIconList.ERROR"
        :color="SBColors.redPrimary"
        :size="12" />
      <span>{{ errorMessage }}</span>
    </div>

    <template slot="modal-footer">
      <div class="modal-footer__buttons flex flex-row flex-nowrap">
        <b-button @click="hide">Cancel</b-button>
        <b-button
          variant="primary"
          :disabled="saving || !complete"
          :class="{loading: saving}"
          class="flex settings__actions--save"
          @click="confirm" >
          <span>Save</span>
          <Spinner
            v-if="saving"
            :size="14"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </div>

    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import Spinner from '@/components/common/Spinner';
import StripeCard from '@/components/common/StripeCard';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'EditPaymentMethodModal',
  components: {
    SBIcon,
    Spinner,
    StripeCard,
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      errorMessage: '',
      saving: false,
      initalFormData: {},
      latestFormData: {},
      cardNumber: '',
      cardExpiration: '',
      cardNumberActive: false,
      cardExpirationActive: false,
      cardCVCActive: false,
      complete: false,
      cardCVC: '',
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    inputActive() {
      return this.cardNumberActive || this.cardExpirationActive || this.cardCVCActive;
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      changePaymentCard: 'user/changePaymentCard',
    }),
    clear() {
      this.errorMessage = '';
    },
    confirm() {
      this.saving = true;
      this.errorMessage = '';
      this.$refs.stripeCard.getStripeToken(this.changeCard);
    },
    changeCard() { // TODO this fails at the moment because activating subscription is an issue.
      this.changePaymentCard({
        data: {
          card_token: this.$refs.stripeCard.token,
          // activate_subscription: true, // TODO temporary fix
          includeMe: true,
        },
        organisationId: this.currentOrganisation.id,
      })
        .then((response) => {
          if (response.status === 200) {
            this.$emit('new-card-last-four');
            this.showToaster('Credit card has been successfully updated', null, null, 'OK');
            this.hide();
          }
        })
        .catch((error) => {
          // if (error.message.indexOf('500')) {
          //   this.errorMessage = 'Card update failed. Please try again later.';
          // }
          this.errorMessage = error.response.data.message;
        })
        .finally(() => {
          this.saving = false;
        });
    },
    handleStripeErrors(error = '') {
      this.errorMessage = error;
      this.saving = false;
    },
    hide() {
      this.$refs.editPaymentMethodModal.hide();
    },
    show(card = null) {
      if (card && card.id) {
        // this.editMember = card;
        // this.populateForm(card);
      }
      this.$refs.editPaymentMethodModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.settings__label {
  margin-top: 0 !important;
  text-transform: unset !important;
}

.number-info {
  box-shadow: 0 1px 3px 0 rgb(48 54 70 / 10%);
  border-radius: 5px;
  border: solid 1px #cfd8dc;
  overflow: hidden;
  &.active {
    box-shadow: 0 0 0 3px #bfdeff !important;
  }
  
  input {
    box-shadow: none !important;
    border-radius: 0px !important;
    border: none !important;
  }
}
</style>
